import TimeSlotService from '../../../services/timeslot-service';
import AppointmentService from '../../../services/appointment-service';

const types = {
    TIMESLOTS_FETCHING: 'TIMESLOTS_FETCHING',
    TIMESLOTS_SUCCESS: 'TIMESLOTS_SUCCESS',
    TIMESLOTS_ERROR: 'TIMESLOTS_ERROR',

    UPDATING_TIMESLOT_FETCHING: 'UPDATING_TIMESLOT_FETCHING',
    UPDATING_TIMESLOT_SUCCESS: 'UPDATING_TIMESLOT_SUCCESS',
    UPDATING_TIMESLOT_ERROR: 'UPDATING_TIMESLOT_ERROR',

    CREATE_TIMESLOT_FETCHING: 'CREATE_TIMESLOT_FETCHING',
    CREATE_TIMESLOT_SUCCESS: 'CREATE_TIMESLOT_SUCCESS',
    CREATE_TIMESLOT_ERROR: 'CREATE_TIMESLOT_ERROR',

    DELETE_TIMESLOT_FETCHING: 'DELETE_TIMESLOT_FETCHING',
    DELETE_TIMESLOT_SUCCESS: 'DELETE_TIMESLOT_SUCCESS',
    DELETE_TIMESLOT_ERROR: 'DELETE_TIMESLOT_ERROR',

    CREATE_APPOINTMENT_FETCHING: 'CREATE_APPOINTMENT_FETCHING',
    CREATE_APPOINTMENT_SUCCESS: 'CREATE_APPOINTMENT_SUCCESS',
    CREATE_APPOINTMENT_ERROR: 'CREATE_APPOINTMENT_ERROR',

    DELETE_APPOINTMENT_FETCHING: 'DELETE_APPOINTMENT_FETCHING',
    DELETE_APPOINTMENT_SUCCESS: 'DELETE_APPOINTMENT_SUCCESS',
    DELETE_APPOINTMENT_ERROR: 'DELETE_APPOINTMENT_ERROR',

    CREATE_TYPE_FETCHING: 'CREATE_TYPE_FETCHING',
    CREATE_TYPE_SUCCESS: 'CREATE_TYPE_SUCCESS',
    CREATE_TYPE_ERROR: 'CREATE_TYPE_ERROR',

    DELETE_TYPE_FETCHING: 'DELETE_TYPE_FETCHING',
    DELETE_TYPE_SUCCESS: 'DELETE_TYPE_SUCCESS',
    DELETE_TYPE_ERROR: 'DELETE_TYPE_ERROR',

    UPDATE_TYPE_FETCHING: 'UPDATE_TYPE_FETCHING',
    UPDATE_TYPE_SUCCESS: 'UPDATE_TYPE_SUCCESS',
    UPDATE_TYPE_ERROR: 'UPDATE_TYPE_ERROR',
};

const state = {
    fetchingTimeSlots: false,
    creatingTimeSlot: false,
    updatingTimeSlot: false,
    deletingTimeSlot: false,
    
    creatingType: false,
    deletingType: false,
    updatingType: false,

    creatingAppointment: false,
    deletingAppointment: false,
};

const actions = {
    async getTimeSlots({commit}) {
        commit(types.TIMESLOTS_FETCHING);

        try {
            const response = await TimeSlotService.getAll();

            commit(types.TIMESLOTS_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.TIMESLOTS_ERROR);

            throw error;
        }
    },

    async createType({commit}, params) {
        commit(types.CREATE_TYPE_FETCHING);

        try {
            const response = await TimeSlotService.createType(params);

            commit(types.CREATE_TYPE_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.CREATE_TYPE_ERROR);

            throw error;
        }
    },

    async updateType({commit}, {id, params}) {
        commit(types.UPDATE_TYPE_FETCHING);

        try {
            const response = await TimeSlotService.updateType(id, params);

            commit(types.UPDATE_TYPE_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.UPDATE_TYPE_ERROR);

            throw error;
        }
    },

    async deleteType({commit}, id) {
        commit(types.DELETE_TYPE_FETCHING);

        try {
            const response = await TimeSlotService.deleteType(id);

            commit(types.DELETE_TYPE_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.DELETE_TYPE_ERROR);

            throw error;
        }
    },

    async createTimeSlot({commit}, params) {
        commit(types.CREATE_TIMESLOT_FETCHING);

        try {
            const response = await TimeSlotService.create(params);

            commit(types.CREATE_TIMESLOT_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.CREATE_TIMESLOT_ERROR);

            throw error;
        }
    },

    async updateTimeSlot({commit}, {id, params}) {
        commit(types.UPDATING_TIMESLOT_FETCHING);

        try {
            const response = await TimeSlotService.update(id, params);

            commit(types.UPDATING_TIMESLOT_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.UPDATING_TIMESLOT_ERROR);

            throw error;
        }
    },

    async deleteTimeSlot({commit}, id) {
        commit(types.DELETE_TIMESLOT_FETCHING);

        try {
            const response = await TimeSlotService.deleteOne(id);

            commit(types.DELETE_TIMESLOT_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.DELETE_TIMESLOT_ERROR);

            throw error;
        }
    },

    async createAppointment({commit}, params) {
        commit(types.CREATE_APPOINTMENT_FETCHING);

        try {
            const response = await AppointmentService.create(params);

            commit(types.CREATE_APPOINTMENT_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.CREATE_APPOINTMENT_ERROR);

            throw error;
        }
    },

    async deleteAppointment({commit}, id) {
        commit(types.DELETE_APPOINTMENT_FETCHING);

        try {
            const response = await AppointmentService.deleteOne(id);

            commit(types.DELETE_APPOINTMENT_SUCCESS);

            return response;
        }
        catch (error) {
            commit(types.DELETE_APPOINTMENT_ERROR);

            throw error;
        }
    },
};

const mutations = {
    [types.CREATE_TYPE_FETCHING](state) {
        state.creatingType = true;
    },
    [types.CREATE_TYPE_SUCCESS](state) {
        state.creatingType = false;
    },
    [types.CREATE_TYPE_ERROR](state) {
        state.creatingType = false;
    },

    [types.UPDATE_TYPE_FETCHING](state) {
        state.updatingType = true;
    },
    [types.UPDATE_TYPE_SUCCESS](state) {
        state.updatingType = false;
    },
    [types.UPDATE_TYPE_ERROR](state) {
        state.updatingType = false;
    },

    [types.DELETE_TYPE_FETCHING](state) {
        state.deletingType = true;
    },
    [types.DELETE_TYPE_SUCCESS](state) {
        state.deletingType = false;
    },
    [types.DELETE_TYPE_ERROR](state) {
        state.deletingType = false;
    },

    [types.TIMESLOTS_FETCHING](state) {
        state.fetchingTimeSlots = true;
    },
    [types.TIMESLOTS_SUCCESS](state) {
        state.fetchingTimeSlots = false;
    },
    [types.TIMESLOTS_ERROR](state) {
        state.fetchingTimeSlots = false;
    },

    [types.UPDATING_TIMESLOT_FETCHING](state) {
        state.updatingTimeSlot = true;
    },
    [types.UPDATING_TIMESLOT_SUCCESS](state) {
        state.updatingTimeSlot = false;
    },
    [types.UPDATING_TIMESLOT_ERROR](state) {
        state.updatingTimeSlot = false;
    },

    [types.CREATE_TIMESLOT_FETCHING](state) {
        state.creatingTimeSlot = true;
    },
    [types.CREATE_TIMESLOT_SUCCESS](state) {
        state.creatingTimeSlot = false;
    },
    [types.CREATE_TIMESLOT_ERROR](state) {
        state.creatingTimeSlot = false;
    },

    [types.DELETE_TIMESLOT_FETCHING](state) {
        state.deletingTimeSlot = true;
    },
    [types.DELETE_TIMESLOT_SUCCESS](state) {
        state.deletingTimeSlot = false;
    },
    [types.DELETE_TIMESLOT_ERROR](state) {
        state.deletingTimeSlot = false;
    },

    [types.CREATE_APPOINTMENT_FETCHING](state) {
        state.creatingAppointment = true;
    },
    [types.CREATE_APPOINTMENT_SUCCESS](state) {
        state.creatingAppointment = false;
    },
    [types.CREATE_APPOINTMENT_ERROR](state) {
        state.creatingAppointment = false;
    },

    [types.DELETE_APPOINTMENT_FETCHING](state) {
        state.deletingAppointment = true;
    },
    [types.DELETE_APPOINTMENT_SUCCESS](state) {
        state.deletingAppointment = false;
    },
    [types.DELETE_APPOINTMENT_ERROR](state) {
        state.deletingAppointment = false;
    },
};

const getters = {
    isFetchingTimeSlots: state => state.fetchingTimeSlots,
    isUpdatingTimeSlot: state => state.updatingTimeSlot,
    isCreatingTimeSlot: state => state.creatingTimeSlot,
    isDeletingTimeSlot: state => state.deletingTimeSlot,

    isCreatingAppointment: state => state.creatingAppointment,
    isDeletingAppointment: state => state.deletingAppointment,

    isCreatingType: state => state.creatingType,
    isDeletingType: state => state.deletingType,
    isUpdatingType: state => state.updatingType,
};

export default {
    state,
    actions,
    mutations,
    getters,
}


// WEBPACK FOOTER //
// ./src/store/modules/planning/index.js